/**
 * Faceted Search - Async
 */

(() => {
    let form = document.querySelector('.js-faceted-search-form');
    let submit_button = document.querySelector(
        '.js-faceted-search-submit-button'
    );
    let language_menu_links = document.querySelectorAll(
        '.js-menu-nested.-language-menu li.lang-item:not(.no-translation) a[href][lang]'
    );

    if (!form || !submit_button) {
        return;
    }

    /**
     * Returns the current URL parameters from the search form, excluding some that are not needed
     * in the front-end.
     *
     * @returns {URLSearchParams} Current URL parameters from the search form
     */
    function getSearchParams() {
        let search = new URLSearchParams(new FormData(form));
        search.delete('override-page'); // remove override-page -parameter
        return search;
    }

    function hideOverlay() {
        // console.log('Hiding overlay...');
        document
            .querySelector('.js-faceted-search-results-overlay')
            ?.classList.add('-hidden');
    }

    function showOverlay() {
        // console.log('Showing overlay...');
        document
            .querySelector('.js-faceted-search-results-overlay')
            ?.classList.remove('-hidden');
    }

    /**
     * Sets the current URL parameters from the search form as the current history state in the
     * browser.
     */
    function setHistory() {
        // console.log('Setting history...');

        window.history.replaceState(
            null,
            '',
            '?' + getSearchParams().toString()
        );
    }

    /**
     * Sets the current URL parameters from the search form as URL parameters of language switcher
     * links that lead to translations of the current page.
     */
    function setLanguageMenu() {
        // console.log('Setting language menu links...');

        language_menu_links.forEach((link) => {
            link.search = getSearchParams().toString();
        });
    }

    function isEventForLoadMoreButton(e) {
        return e.target.classList.contains(
            'js-htmx-faceted-search-load-more-button'
        );
    }

    form.addEventListener('htmx:beforeRequest', (e) => {
        if (isEventForLoadMoreButton(e)) {
            return;
        }

        showOverlay();

        form.querySelector('#search-results').classList.add('-invalid');
    });

    form.addEventListener('htmx:afterOnLoad', (e) => {
        if (isEventForLoadMoreButton(e)) {
            return;
        }

        let results = document.querySelector('#search-results');

        // Make loaded search results backwards focusable
        H_Tools?.stickyheader?.makeBackwardsFocusable(results);

        // Enable dictionary entries in loaded search results
        H_Tools?.dictionary?.enableDictionaryEntries(results);

        setHistory();
        setLanguageMenu();
        hideOverlay();
    });

    /**
     * We also need to set language menu links at page load because search params aren't in language
     * menu links automatically on pages with the faceted search block.
     */
    setLanguageMenu();
})();
